import styled from 'styled-components';
import { media } from 'styledComponents/utils';

export const SectionWrapper = styled.div`
@media (max-width: 374px) {
  padding: 25px 6%;
}
background-color: white;
position: relative;
z-index: 5;
padding: 25px;
margin: 0 auto;
margin-top: -10px;
max-width: 375px;
width: 100%;
overflow: hidden;
box-shadow: 0 2px 4px rgba(51, 51, 51, 0.08);
${media.tablet`
  padding: 40px 60px;
  max-width: 100%;  
  margin-top: 0px;
`}

${media.desktop`
  max-width: 800px;
  margin-right: 40px;
  margin-top: 10px;
  padding: 40px;
`}

.stripe-element {
  background-color: #8080800f;
  margin-left: 5px;
  @media (max-width: 374px) {
    margin-left: 0px;
  }
}

.content{
  display: none;
  ${props => props.activeSection === props.section && 'display: block;'}
}

h2 {
  font-size: 18px;
  margin-top: 15px;
}
hr {
  margin-bottom: 10px;
}
.first-child-target > div:first-child {
  div {
    border-top: none;
  }
}
`;

export const CheckWrapper = styled.div`
  display: flex;
  margin-top: 15px;
  input {
    visibility: hidden;
  }
  label {
    font-size: 10px;
    font-family: inherit;
    text-transform: none;
    opacity: .7;
    position: relative;
    margin-left: 5px;
    margin-top: 3px;
    ${media.tablet`
      margin-top: 6px;
    `}
  }
`;

export const Checkbox = styled.div`
  width: 15px;
  height: 15px;
  min-width: 15px;
  border-radius: 2px;
  margin-left: -13px;
  cursor: pointer;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  padding-bottom: 3px;
  svg {
    height: 80%;
    width: 80%;
    margin-top: -10px;
  }
  ${props => props.checked ? css`
    background-color: #000000;
    svg {
      path {
        fill: white;
      }
    }
  ` : css`
    background-color: white;
    border: 1px solid #000000;
    svg {
      display: none;
    }
  `}
`;

export const Button = styled.div`
  background-color: #000000;
  color: white;
  padding: 15px 25px;
  width: fit-content;
  border-radius: 50px;
  font-size: 13px;
  margin-top: 30px;
  margin-bottom: 15px;
  cursor: pointer;
`;
